/**
 * @fileoverview Top-level provider composition.
 * @description Mounts the i18next provider, the TanStack Query client, and the router once,
 * above every page, so App.tsx itself stays trivial.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { QueryClientProvider } from '@tanstack/react-query'
import { I18nextProvider } from 'react-i18next'
import { RouterProvider } from 'react-router'

import { appRouter } from '@/app/routing/AppRoutes'
import { i18next } from '@/shared/lib/i18n/i18n.config'
import { queryClient } from '@/shared/lib/query-client'

/**
 * @component
 */
function AppProviders() {
  return (
    <I18nextProvider i18n={i18next}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={appRouter} />
      </QueryClientProvider>
    </I18nextProvider>
  )
}

export default AppProviders
